import { render, staticRenderFns } from "./shopLeaderboard.vue?vue&type=template&id=72631538&scoped=true&"
import script from "./shopLeaderboard.vue?vue&type=script&lang=js&"
export * from "./shopLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./shopLeaderboard.vue?vue&type=style&index=0&id=72631538&lang=scss&scoped=true&"
import style1 from "./shopLeaderboard.vue?vue&type=style&index=1&id=72631538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72631538",
  null
  
)

export default component.exports